import React from 'react'
import { Stack, Button, IconButton } from '@chakra-ui/react'
import { GrMore, GrFavorite, GrPlay } from 'react-icons/gr'

export const ButtonIcons = () => {
    return (
        <Stack isInline mt={1} w="fit-content" flexWrap="wrap" px={0}>
            <Button
                leftIcon={<GrPlay />}
                type="button"
                variant="solid"
                fill="currentColor"
                size="sm"
                fontWeight="light"
                aria-label="play"
                mr={1}
                borderRadius="none">
                PLAY ALL
            </Button>
            <IconButton
                icon={<GrFavorite />}
                size="sm"
                fill="currentColor"
                borderRadius="full"
                aria-label="like"
                mr={1}>
            </IconButton>
            <IconButton
                icon={<GrMore />}
                size="sm"
                fill="currentColor"
                borderRadius="full"
                aria-label="show more" ml={0}>
            </IconButton>
        </Stack>
    )
}